export default __webpack_public_path__ + "19e6083ec06e036aec49aca370f2dee4.svg";